module.exports = __webpack_public_path__ + "media/images/gathered_creative-08879f923315a55b84fa868918a41d20.png";